export enum County {
    Unknown = 'Unknown',
    Oakland = 'Oakland',
    Wayne = 'Wayne',
    Washtenaw = 'Washtenaw',
    Macomb = 'Macomb',
}
